var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({position: 'relative', top: _vm.top || '84px', width:'100%', height: '169px', marginBottom: '80px'})},[_c('LeftTurn',{style:({
            position: 'absolute',
            top: '56px',
            left: '6.25%',
            zIndex: '10'
        }),attrs:{"circling":_vm.status == 'completed',"extendEnd":_vm.extendEnd,"returnLevel":_vm.returnLevel}}),_c('Trail',{style:({
            width: '62%',
            left: '15%',
            position: 'absolute',
            top: '13.5px',
            zIndex: '11'
        }),attrs:{"className":"journey-return-trail-scoped","completed":_vm.status == 'completed',"width":"75%","circling":_vm.status == 'completed'}}),_c('Trail',{style:({
            width: '62%',
            left: '15%',
            position: 'absolute',
            top: '13.5px',
            zIndex: '10'
        }),attrs:{"className":"journey-return-trail-scoped","completed":false,"width":"75%","circling":false}}),_c('RightTurn',{style:({position: 'absolute',
            left: _vm.startpoint || '73%',
            top: '-115px'}),attrs:{"circling":_vm.status == 'completed',"extendBegin":_vm.extendBegin,"returnLevel":_vm.returnLevel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }